import { Stack, Typography, useTheme, SxProps, Box } from '@mui/material';
import React, { ReactNode } from 'react';
import CAppPaper from '../../../../../app/components/CAppPaper';
import AppCustomIcon from '../../../../../app/features/icon/AppIcon';

type ItemProps = {
	id: string;
	label: string;
	value: string | number | ReactNode;
	inline?: boolean;
};

type CFundInformationBlockProps = {
	id?: string;
	icon: string;
	title: string;
	items: ItemProps[];
};
const CFundInformationBlock = (props: CFundInformationBlockProps) => {
	const { id, icon, title, items } = props;

	return (
		<CAppPaper id={id} variant="outlined" sx={{ padding: '15px' }}>
			<Stack direction="row" alignItems="center">
				<AppCustomIcon tag={icon} sx={{ marginRight: '12px' }} />
				<Typography variant="h3" component="h3" sx={{ margin: '0px', padding: '0px' }}>
					{title}
				</Typography>
			</Stack>
			<Box>
				{items &&
					items.map((item, index) => {
						return (
							<Item key={index} id={item.id} label={item.label} value={item.value} inline={item.inline} />
						);
					})}
			</Box>
		</CAppPaper>
	);
};

export const Item = (props: ItemProps) => {
	const theme = useTheme();
	const sxItem = {
		marginTop: '15px',
		'.label': {
			fontWeight: 600,
			fontSize: '0.82rem',
			lineHeight: '1.8',
			color: theme.palette.mode === 'dark' ? '#FFF' : '#6F8098',
		},
		'.value': {
			fontWeight: 400,
			fontSize: '0.9rem',
			lineHeight: '1.5',
			color: theme.palette.mode === 'dark' ? '#FFF' : theme.palette.primary.main,
		},
	} as SxProps;
	return (
		<Box sx={sxItem} className="fund-information-item" data-id={props.id}>
			<Stack
				direction={props.inline ? 'row' : 'column'}
				sx={props.inline ? { justifyContent: 'space-between', alignItems: 'center' } : undefined}
			>
				<Box className="label">{props.label}</Box>
				<Box className="value">{props.value}</Box>
			</Stack>
		</Box>
	);
};

export default CFundInformationBlock;
